import { Box, CircularProgress } from '@mui/material'

const Spinner = () => (
  <Box
    sx={{
      position: 'absolute',
      left: '0',
      top: '0',
      display: 'flex',
      height: '100%',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress />
  </Box>
)

export default Spinner
